import { Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";
import { CurrencyPipe } from "@angular/common";

const PADDING = "000000";

@Pipe({ name: "myCurrency" })
export class MyCurrencyPipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    // TODO comes from configuration settings
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  transform(
    value: number | string,
    currencyCode: string = "USD",
    symbolnarrow: string = "symbol-narrow",
    fractionSize: number = 2,
    withCode: boolean = false
  ) {
    if (
      currencyCode == undefined ||
      currencyCode == null ||
      currencyCode == ""
    ) {
      currencyCode = "USD";
    }
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isNaN(Number(value))
    ) {
      let retValue = "";
      // retValue = new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
      retValue = new CurrencyPipe("en").transform(
        value,
        currencyCode,
        false,
        "1.2-2"
      );
      retValue = retValue.substr(3, retValue.length);
      let symbal = "$";
      let flag = false;
      let countrycollection = JSON.parse(localStorage.CountryCollection);
      countrycollection.forEach(function(country) {
        if (flag === true) {
          return;
        }
        country.Currencies.forEach(function(currency) {
          if (flag === true) {
            return;
          }
          if (currency.CurrencyCode == currencyCode) {
            symbal = "&#" + currency.Unicode + ";";
            flag = true;
            return;
          }
        });
      });
      retValue = symbal + retValue;
      if (withCode) {
        retValue = retValue + " " + currencyCode;
      }

      // if (retValue.indexOf('MX') >= 0) {
      //   retValue = retValue.replace('MX', '');
      // }
      return retValue; //new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
    } else {
      return value;
    }
  }

  transformEx(
    value: number | string,
    currencyCode: string = "USD",
    symbolnarrow: string = "symbol-narrow",
    fractionSize: number = 2,
    withCode: boolean = false
  ) {
    if (
      currencyCode == undefined ||
      currencyCode == null ||
      currencyCode == ""
    ) {
      currencyCode = "USD";
    }
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isNaN(Number(value))
    ) {
      let retValue = "";
      // retValue = new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
      retValue = new CurrencyPipe("en").transform(
        value,
        currencyCode,
        false,
        "1.2-2"
      );
      retValue = retValue.substr(3, retValue.length);
      let symbal = "$";
      retValue = symbal + retValue;
      if (withCode) {
        retValue = retValue + " " + currencyCode;
      }
      return retValue;
    } else {
      return value;
    }
  }

  amountFormat(
    value: number | string,
    currencyCode: string = "USD",
    fractionSize: number = 2
  ) {
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isNaN(Number(value))
    ) {
      let retValue = "";
      retValue = new CurrencyPipe("en").transform(
        value,
        currencyCode,
        false,
        "1.2-2"
      );
      if (retValue.indexOf("MX") >= 0) {
        retValue = retValue.replace("MX", "");
      }
      return retValue; //new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
    } else {
      return value;
    }
  }

  parse(value: string, fractionSize: number = 2): string {
    value = value.toString().replace(/[^0-9-.]/g, "");
    let [integer, fraction = ""] = (value || "").split(this.DECIMAL_SEPARATOR);

    integer = integer.replace(new RegExp(this.THOUSANDS_SEPARATOR, "g"), "");

    fraction =
      parseInt(fraction, 10) > 0 && fractionSize > 0
        ? this.DECIMAL_SEPARATOR +
          (fraction + PADDING).substring(0, fractionSize)
        : "";
    integer = integer == "" ? "0" : integer;
    fraction = fraction == "" ? ".00" : fraction;
    return integer + fraction;
  }
}

@Pipe({ name: "amountFormat" })
export class AmountFormat implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }
  transform(
    value: number | string,
    currencyCode: string = "",
    fractionSize: number = 2
  ) {
    if (value == undefined || value == null || value == "") {
      value = 0;
    }
    if (!isNaN(Number(value))) {
      let retValue = "";
      retValue = new DecimalPipe("en").transform(value, "1.2-2");
      return retValue;
    } else {
      return value;
    }
  }
}
@Pipe({ name: "myCurrencyExchangeRate" })
export class MyCurrencyExchangeRatePipe implements PipeTransform {
  private DECIMAL_SEPARATOR: string;
  private THOUSANDS_SEPARATOR: string;

  constructor() {
    // TODO comes from configuration settings
    this.DECIMAL_SEPARATOR = ".";
    this.THOUSANDS_SEPARATOR = ",";
  }

  transform(
    value: string,
    currencyCode: string = "USD",
    symbolnarrow: string = "symbol-narrow",
    fractionSize: string = "1.2.2",
    withCode: boolean = false
  ) {
    if (
      currencyCode == undefined ||
      currencyCode == null ||
      currencyCode == ""
    ) {
      currencyCode = "USD";
    }
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isNaN(Number(value)) &&
      value.toString() !== "0"
    ) {
      let retValue = "";
      const decimalvalues = value.split(".")[1].length;
      // This logic is written for implementing 0 post decimal
      const manipulatedFraction = "1." + decimalvalues + "-" + decimalvalues;
      retValue = new CurrencyPipe("en").transform(
        value,
        currencyCode,
        false,
        manipulatedFraction
      );
      retValue = retValue.substr(3, retValue.length);
      let symbal = "$";
      let flag = false;
      const countrycollection = JSON.parse(localStorage.CountryCollection);
      countrycollection.forEach(function(country) {
        if (flag === true) {
          return;
        }
        country.Currencies.forEach(function(currency) {
          if (flag === true) {
            return;
          }
          if (currency.CurrencyCode == currencyCode) {
            symbal = "&#" + currency.Unicode + ";";
            flag = true;
            return;
          }
        });
      });
      retValue = symbal + retValue;
      if (withCode) {
        retValue = retValue + " " + currencyCode;
      }

      // if (retValue.indexOf('MX') >= 0) {
      //   retValue = retValue.replace('MX', '');
      // }
      return retValue; //new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
    } else {
      return value;
    }
  }

  transformEx(
    value: string,
    currencyCode: string = "USD",
    symbolnarrow: string = "symbol-narrow",
    fractionSize: number = 2,
    withCode: boolean = false
  ) {
    if (
      currencyCode == undefined ||
      currencyCode == null ||
      currencyCode == ""
    ) {
      currencyCode = "USD";
    }
    if (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !isNaN(Number(value)) &&
      value.toString() !== "0"
    ) {
      let retValue = "";
      // retValue = new CurrencyPipe('en').transform(value, currencyCode, true, '1.2-2');
      const decimalvalues = value.split(".")[1].length;
      // This logic is written for implementing 0 post decimal
      const manipulatedFraction = "1." + decimalvalues + "-" + decimalvalues;
      retValue = new CurrencyPipe("en").transform(
        value,
        currencyCode,
        false,
        manipulatedFraction
      );
      retValue = retValue.substr(3, retValue.length);
      const symbal = "$";
      retValue = symbal + retValue;
      if (withCode) {
        retValue = retValue + " " + currencyCode;
      }
      return retValue;
    } else {
      return value;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/_pipe/mycurreny.ts